
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CalculatorLayout } from '@/components/calculator/layout/CalculatorLayout';
import { images } from '@/assets/images';
import { IntegratedCalculatorInterface } from '@/components/calculator/IntegratedCalculatorInterface';
import { CalculatorErrorBoundary } from '@/components/calculator/CalculatorErrorBoundary';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { useCalculatorNavigation } from '@/hooks/calculator/useCalculatorNavigation';

import { HomequestBanner } from '@/components/calculator/HomequestBanner';

const Calculator: React.FC = () => {
  const { handleNavigateToBuyingPower } = useCalculatorNavigation();
  const location = useLocation();
  const [showHomequestBanner, setShowHomequestBanner] = useState(false);

  
  // Check if data was imported from HomeQuest
  useEffect(() => {
    const state = location.state as { homequestData?: any; source?: string } | null;
    if (state?.homequestData && state?.source === 'homequest') {
      setShowHomequestBanner(true);
    }
  }, [location.state]);

  return (
    <ProtectedRoute>
      <CalculatorErrorBoundary>
        <div className="min-h-screen bg-background">
          <CalculatorLayout onNavigateToBuyingPower={handleNavigateToBuyingPower}>
            {showHomequestBanner && (
              <HomequestBanner 
                onDismiss={() => setShowHomequestBanner(false)}
              />
            )}
            <IntegratedCalculatorInterface />
          </CalculatorLayout>
        </div>
      </CalculatorErrorBoundary>
    </ProtectedRoute>
  );
};

export default Calculator;
